export default __webpack_public_path__ + "static/home_page_measurement-8816746c343a4b3063307348fcfc82b2.mp4";